import { baseApi } from "../baseApi";

export const rfqsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getRfqs: builder.query({
      query: (params = {}) => ({
        url: `/vendor/rfqs`,
        method: "GET",
        params,
      }),
      providesTags: ["RFQs"],
    }),
    getRfq: builder.query({
      query: (id) => ({
        url: `/vendor/rfqs`,
        method: "GET",
        params: id,
      }),
      providesTags: ["RFQs"],
    }),
    getRfqHistory: builder.query({
      query: (params = {}) => ({
        url: `/vendor/quotes/history`,
        method: "GET",
        params,
      }),
      providesTags: ["RFQs"],
    }),
    submitBid: builder.mutation({
      query: (bid) => ({
        url: `/vendor/rfqs/quotes`,
        method: "POST",
        body: bid,
      }),
      invalidatesTags: ["RFQs"],
    }),
    getOpo: builder.query({
      query: () => ({
        url: `/vendor/quotes/po`,
        method: "GET",
      }),
      providesTags: ["OPOs"],
    }),
  }),
});

export const {
  useGetRfqsQuery,
  useGetRfqQuery,
  useSubmitBidMutation,
  useGetRfqHistoryQuery,
} = rfqsApi;
